import {
  createExternalRouteRef,
  createRouteRef,
  createSubRouteRef,
} from '@backstage/frontend-plugin-api';

export const infoRouteRef = createRouteRef();

export const settingsRouteRef = createRouteRef();

export const featureFlagsRouteRef = createSubRouteRef({
  parent: settingsRouteRef,
  path: '/feature-flags',
});

export const catalogEntityRouteRef = createExternalRouteRef({
  params: ['namespace', 'kind', 'name'],
});
